import { createPluginFactory } from '@udecode/plate';

export const ELEMENT_COL = 'col';

export const createColPlugin = createPluginFactory({ key: ELEMENT_COL, isElement: true });
